
import MyDialog from '@/components/unit/dialog/index.js'
// 判断
export default {
    methods: {
        async frontIdCardExample() {
            return new Promise((resolve, reject) => {
                MyDialog({ link: '/page/home/idCardExample.vue', type: 'front' }).then(res => {
                    resolve()
                }).catch(() => {
                    reject()
                })
            })
        },
        async reverseIdCardExample() {
            return new Promise((resolve, reject) => {
                MyDialog({ link: '/page/home/idCardExample.vue', type: 'reverse' }).then(res => {
                    resolve()
                }).catch(() => {
                    reject()
                })
            })
        },
        async selectUploadIdCardWay() {
            return new Promise((resolve, reject) => {
                MyDialog({ link: '/page/home/idCardUploadWay.vue' }).then(res => {
                    resolve(res)
                }).catch((res) => {
                    reject(res)
                })
            })
        }
    }
}
